(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      const sliders = document.querySelectorAll('[data-banner-slider]');
  
      sliders.forEach(container => {
        const slides = container.querySelectorAll('.banner-slide');
        const totalSlides = slides.length;
  
        // Skip if only one slide
        if (totalSlides <= 1) return;
  
        let currentSlide = 0;
        let slideInterval;
        const interval = parseInt(container.dataset.slideInterval) || 4000;
        const autoSlide = container.dataset.autoSlide === 'true';
  
        function showSlide(index) {
          slides.forEach(slide => {
            slide.style.opacity = '0';
            slide.style.pointerEvents = 'none';
          });
          slides[index].style.opacity = '1';
          slides[index].style.pointerEvents = 'auto';
          currentSlide = index;
        }
  
        function nextSlide() {
          showSlide((currentSlide + 1) % totalSlides);
        }
  
        function startSlider() {
          if (autoSlide) {
            slideInterval = setInterval(nextSlide, interval);
          }
        }
  
        function stopSlider() {
          clearInterval(slideInterval);
        }
  
        // Initialize
        showSlide(0);
        startSlider();
  
        // Pause on hover
        container.addEventListener('mouseenter', stopSlider);
        container.addEventListener('mouseleave', startSlider);
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["live-chat"] && !Shopify.designMode) return;
  try {
    
  const section = document.querySelector('.live-chat-section');
  if (section) {
    section.addEventListener('click', (event) => {
      if (event.target.closest('[data-live-chat-toggle]')) {
        if (typeof openChatButtonClick === 'function') {
          openChatButtonClick();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-announcement-bar"]) return;
  try {
    
  const slides = document.querySelectorAll('.new-announcement-bar__slide');
  if (!slides.length) return;

  let currentSlide = 0;
  let autoSlideIntervalId;
  const autoSlideEnabled = slides[0].dataset.autoSlide === 'true';
  const slideIntervalDuration = slides[0].dataset.slideInterval ? parseInt(slides[0].dataset.slideInterval) : 3000;
  const activeClass = 'new-announcement-bar__slide--is-active';

  function showSlide(index) {
    slides.forEach((slide, i) => {
      const isActive = i === index;
      slide.classList.toggle(activeClass, isActive);
    });
  }

  function nextSlide() {
    currentSlide = (currentSlide + 1) % slides.length;
    showSlide(currentSlide);
  }

  function startAutoSlide() {
    autoSlideIntervalId = setInterval(nextSlide, slideIntervalDuration);
  }

  function stopAutoSlide() {
    clearInterval(autoSlideIntervalId);
  }

  if (autoSlideEnabled) {
    startAutoSlide();

    slides.forEach((slide) => {
      slide.addEventListener('mouseenter', () => {
        stopAutoSlide();
      });
      slide.addEventListener('mouseleave', () => {
        startAutoSlide();
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-collection-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const wishlistButton = event.target.closest('.js-add-to-wishlist');
    if (wishlistButton) {
      fetchProductDetails(event);
      return;
    }

    const sizeButton = event.target.closest('.js-product-card-size');
    if (sizeButton) {
      event.preventDefault();
      event.stopPropagation();

      const productItem = sizeButton.closest('.new-collection-slide__item');
      const sizesContainer = sizeButton.closest('.js-product-card-sizes');
      if (!sizesContainer || !productItem) return;

      productItem.classList.add('is-adding-to-cart');
      sizesContainer.classList.add('is-loading');

      const variantId = sizeButton.dataset.variantId;
      if (!variantId) return;

      const formData = {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((cart) => {
          document.dispatchEvent(
            new CustomEvent('cart:added', {
              detail: {
                cart: cart,
              },
            })
          );
        })
        .catch((error) => {
          console.error('Error adding to cart:', error);
        })
        .finally(() => {
          productItem.classList.remove('is-adding-to-cart');
          sizesContainer.classList.remove('is-loading');
        });
      return;
    }

    const quickAddButton = event.target.closest('.js-quick-add');
    if (quickAddButton) {
      event.preventDefault();

      try {
        const product = JSON.parse(quickAddButton.dataset.product);
        console.log('Product Details:', product);
      } catch (e) {
        console.error('Error parsing product data:', e);
      }
      return;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-header"]) return;
  try {
    
  // DEBUGGING IN BROWSER:
  // window.menuDebug = true;

  const header = document.querySelector('.new-header');
  const announcementBar = document.querySelector('.new-announcement-bar');
  const mobileMenuToggle = document.querySelectorAll('.js-new-header-mobile-toggle');
  const mobileMenu = document.querySelector('.js-new-header-menu');
  const desktopMenuHeader = document.querySelector('.js-new-header-menu-desktop');
  const desktopMenu = document.querySelector('.js-new-desktop-menu');
  const desktopMenuParents = document.querySelectorAll('.js-new-desktop-header-menu-parent');
  const desktopMenuImages = document.querySelectorAll('.js-new-desktop-menu-images');
  const desktopSearchContainer = document.querySelector('.new-search-desktop');
  const mobileSearchContainer = document.querySelector('.js-search-modal');
  const desktopSearchInput = document.querySelector('.new-header__main-search--desktop');
  const desktopSearchInputContainer = document.querySelector('.new-header__search');
  const wishlistButtons = document.querySelectorAll('.js-add-to-wishlist');

  const stickyClass = 'new-header--is-sticky';
  const sentinelClass = 'new-header-sentinel';
  const hoverClass = 'is-hover';
  const DESKTOP_MENU_ACTIVE_CLASS = 'new-desktop-header-menus--is-active';
  const DESKTOP_MENU_PARENT_MENU_ACTIVE_CLASS = 'new-desktop-header-menus__parent--is-active';
  const DESKTOP_MENU_IMAGES_ACTIVE_CLASS = 'new-desktop-header-menus__images--is-active';
  const SEARCH_DESKTOP_ACTIVE_CLASS = 'new-search-desktop--is-active';
  const SEARCH_MOBILE_ACTIVE_CLASS = 'new-search-modal--is-active';
  const LOCK_SCROLL_CLASS = 'lock-scroll';

  if (!document.querySelector('.js-page-overlay')) {
    const element = document.createElement('div');
    element.classList.add('page-overlay');
    element.classList.add('js-page-overlay');
    header.parentNode.insertBefore(element, header);
  }

  function preventDefault(e) {
    e.preventDefault();
  }

  window.scrollUtils = {
    disableScroll: function () {
      document.body.classList.add(LOCK_SCROLL_CLASS);
    },
    enableScroll: function () {
      document.body.classList.remove(LOCK_SCROLL_CLASS);
    },
  };

  function adjustMenuImagesAspectRatio(parentMenu, imagesContainer) {
    if (!parentMenu || !imagesContainer) return;

    const menuColumns = parentMenu.querySelectorAll('.new-desktop-header-menus__children');
    const imageElements = imagesContainer.querySelectorAll('.new-desktop-header-menus__image');
    if (menuColumns.length === 0 || imageElements.length === 0) return;

    const maxImageWidth = 266; // The width of an image at max aspect ratio (4/6 @ 400px height)
    const gap = 60; // The gap between menu columns and between menus/images
    const padding = 40; // Total horizontal padding of the menu container

    const totalMenuWidth = parentMenu.offsetWidth;
    const availableWidthForImages = desktopMenu.clientWidth - totalMenuWidth - gap - padding;
    const widthPerImage = availableWidthForImages / imageElements.length;

    // Don't let images get wider than their max defined width
    const finalImageWidth = Math.min(widthPerImage, maxImageWidth);

    const imageHeight = 400;
    const newAspectRatio = `${finalImageWidth} / ${imageHeight}`;

    imagesContainer.style.setProperty('--dynamic-aspect-ratio', newAspectRatio);
  }

  function showDesktopMenu(id) {
    if (!desktopMenu) return;

    if (
      desktopSearchContainer?.classList.contains(SEARCH_DESKTOP_ACTIVE_CLASS) &&
      typeof window.closeSearchModal === 'function'
    ) {
      window.closeSearchModal();
      desktopSearchInputContainer?.classList.remove('is-active-desktop');
      addHover();
    }

    const pageOverlay = document.querySelector('.js-page-overlay');
    if (pageOverlay) {
      pageOverlay.classList.add('is-visible');
      window.scrollUtils.disableScroll();
    }

    desktopMenu.classList.add(DESKTOP_MENU_ACTIVE_CLASS);

    const matchingParentMenu = Array.from(desktopMenuParents).find((parent) => parent.dataset.id === id);

    const matchingImages = desktopMenuImages[id];

    desktopMenuParents.forEach((menu) => menu.classList.remove(DESKTOP_MENU_PARENT_MENU_ACTIVE_CLASS));

    desktopMenuImages.forEach((image) => image.classList.remove(DESKTOP_MENU_IMAGES_ACTIVE_CLASS));

    if (matchingParentMenu) {
      if (desktopMenu._timeout) clearTimeout(desktopMenu._timeout);

      if (matchingImages) {
        matchingImages.classList.add(DESKTOP_MENU_IMAGES_ACTIVE_CLASS);
      }

      desktopMenu._timeout = setTimeout(() => {
        matchingParentMenu.classList.add(DESKTOP_MENU_PARENT_MENU_ACTIVE_CLASS);
        const children = matchingParentMenu.querySelectorAll('.new-desktop-header-menus__children');
        children.forEach((child, index) => {
          const delay = Math.sqrt(index) * 60;
          child.style.transitionDelay = `${delay}ms`;
        });
        adjustMenuImagesAspectRatio(matchingParentMenu, matchingImages);
      }, 200);
    }
  }

  function hideDesktopMenu() {
    if (window.menuDebug) {
      console.log('Menu close prevented (debug mode). Set window.menuDebug = false to disable.');
      return;
    }

    if (!desktopMenu) return;

    const pageOverlay = document.querySelector('.js-page-overlay');
    if (pageOverlay) {
      pageOverlay.classList.remove('is-visible');
    }

    desktopMenu.classList.remove(DESKTOP_MENU_ACTIVE_CLASS);
    desktopMenuParents.forEach((menu) => menu.classList.remove(DESKTOP_MENU_PARENT_MENU_ACTIVE_CLASS));
    desktopMenuImages.forEach((image) => image.classList.remove(DESKTOP_MENU_IMAGES_ACTIVE_CLASS));
    const allChildren = document.querySelectorAll('.new-desktop-header-menus__children');
    allChildren.forEach((child) => {
      child.style.transitionDelay = '';
    });
  }

  function addHover() {
    if (header.classList.contains(stickyClass)) return;

    header.classList.add(hoverClass);
    if (announcementBar) announcementBar.classList.add(hoverClass);
  }

  function removeHover(event) {
    if (window.menuDebug) {
      return;
    }

    const relatedTarget = event.relatedTarget;

    if (
      relatedTarget &&
      (header.contains(relatedTarget) ||
        (announcementBar && announcementBar.contains(relatedTarget)) ||
        (desktopMenu && desktopMenu.contains(relatedTarget)))
    ) {
      return;
    }

    // Only enable scroll if the minicart or search modal is not active
    const isMinicartOpen = document.body.classList.contains('is-open-minicart');
    const isMobileMenuOpen = mobileMenu.classList.contains('new-header-menus--is-active');
    const isDesktopSearchOpen = desktopSearchContainer?.classList.contains(SEARCH_DESKTOP_ACTIVE_CLASS);
    const isMobileSearchOpen = mobileSearchContainer?.classList.contains(SEARCH_MOBILE_ACTIVE_CLASS);

    // Check if the search modal should stay open
    const shouldKeepSearchOpen = isDesktopSearchOpen && desktopSearchInput && desktopSearchInput.value.trim() !== '';

    // Only remove the hover states if we aren't keeping the search open
    if (!shouldKeepSearchOpen) {
      header.classList.remove(hoverClass);
      if (announcementBar && !document.body.classList.contains('new-announcement-bar-visible')) {
        announcementBar.classList.remove(hoverClass);
      }
    }

    if (isDesktopSearchOpen) {
      if (shouldKeepSearchOpen) return;
      if (typeof window.closeSearchModal === 'function') {
        window.closeSearchModal();
      }
    } else if (!isMinicartOpen && !isMobileMenuOpen && !isMobileSearchOpen) {
      window.scrollUtils.enableScroll();
    }

    // DEBBUGING
    hideDesktopMenu();
  }

  if (desktopMenuHeader) {
    desktopMenuHeader.addEventListener('mouseover', (event) => {
      const link = event.target.closest('a[data-id]');
      if (link) {
        const dataId = link.getAttribute('data-id');
        showDesktopMenu(dataId);
      }
    });
  }

  header.addEventListener('mouseenter', addHover);
  header.addEventListener('mouseleave', removeHover);

  if (announcementBar) {
    announcementBar.addEventListener('mouseenter', addHover);
    announcementBar.addEventListener('mouseleave', removeHover);
  }

  if (desktopMenu) {
    desktopMenu.addEventListener('mouseleave', removeHover);
  }

  if (document.body.classList.contains('template-index')) {
    const sentinelElement = document.createElement('div');
    sentinelElement.classList.add(sentinelClass);
    header.parentNode.insertBefore(sentinelElement, header);
    const sentinel = document.querySelector(`.${sentinelClass}`);
    const desktopMenu = document.querySelector('.js-new-desktop-menu');

    const applySticky = () => {
      if (window.scrollY > 0) {
        header.classList.add(stickyClass);
        if (window.matchMedia('(min-width: 768px)').matches && desktopMenu) {
          desktopMenu.classList.add('new-desktop-header-menus--is-header-sticky');
        }
      }
    };

    // Initial checks to handle page load with scroll position
    applySticky();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applySticky);
    }
    window.addEventListener('load', () => {
      applySticky();
      setTimeout(applySticky, 100);
    });

    // Handle scroll during page load
    const earlyScrollHandler = () => {
      applySticky();
      window.removeEventListener('scroll', earlyScrollHandler);
    };
    window.addEventListener('scroll', earlyScrollHandler, { passive: true });

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          header.classList.add(stickyClass);
          if (window.matchMedia('(min-width: 768px)').matches) {
            desktopMenu.classList.add('new-desktop-header-menus--is-header-sticky');
            removeHover({ relatedTarget: null });
          }
        } else {
          header.classList.remove(stickyClass);
          if (window.matchMedia('(min-width: 768px)').matches) {
            desktopMenu.classList.remove('new-desktop-header-menus--is-header-sticky');
          }
        }
      },
      { threshold: [0] }
    );
    observer.observe(sentinel);
  } else {
    // For non-index pages, also check initial scroll position
    header.classList.add(stickyClass);
    if (window.matchMedia('(min-width: 768px)').matches) {
      const desktopMenu = document.querySelector('.js-new-desktop-menu');

      window.addEventListener('scroll', () => {
        if (window.scrollY > 20) {
          desktopMenu.classList.add('new-desktop-header-menus--is-header-sticky');
        } else {
          desktopMenu.classList.remove('new-desktop-header-menus--is-header-sticky');
        }
      });
    }
  }

  mobileMenuToggle.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const menuActiveClass = 'new-header-menus--is-active';
      const isOpening = !mobileMenu.classList.contains(menuActiveClass);
      
      mobileMenu.classList.toggle(menuActiveClass);

      if (isOpening) {
        // Close minicart if open
        if (document.body.classList.contains('is-open-minicart')) {
          document.body.classList.remove('is-open-minicart');
        }
        document.body.classList.add('is-open-mobile-menu');
        window.scrollUtils.disableScroll();
      } else {
        document.body.classList.remove('is-open-mobile-menu');
        window.scrollUtils.enableScroll();
      }
    });
  });

  if (announcementBar) {
    announcementBar.addEventListener('mouseenter', addHover);
    announcementBar.addEventListener('mouseleave', removeHover);

    const announcementBarHeight = announcementBar.offsetHeight;
    let lastScrollY = window.scrollY;

    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;
      const isDesktopSearchOpen = desktopSearchContainer?.classList.contains(SEARCH_DESKTOP_ACTIVE_CLASS);
      if (!isDesktopSearchOpen) {
        removeHover({ relatedTarget: null });
      }

      if (currentScrollY < lastScrollY && currentScrollY > announcementBarHeight) {
        // Scrolling up and past the announcement bar
        header.classList.add('new-header--is-scrolled');
        document.body.classList.add('new-announcement-bar-visible');
        announcementBar.classList.add(hoverClass);
        announcementBar.classList.add('is-sticky');
      } else if (currentScrollY > lastScrollY && currentScrollY > announcementBarHeight) {
        // Scrolling down and past the announcement bar
        header.classList.remove('new-header--is-scrolled');
        document.body.classList.remove('new-announcement-bar-visible');
      } else if (currentScrollY <= announcementBarHeight) {
        // At the top of the page
        header.classList.remove('new-header--is-scrolled');
        document.body.classList.remove('new-announcement-bar-visible');
        announcementBar.classList.remove(hoverClass);
        announcementBar.classList.remove('is-sticky');
      }

      lastScrollY = currentScrollY;
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-help-accordion"] && !Shopify.designMode) return;
  try {
    
  /**
   * Handles two concerns for the help accordion:
   * 1. Animated close — intercepts summary clicks to let the CSS
   *    grid-template-rows transition finish before removing [open].
   * 2. Live chat links — delegates clicks on chat links/buttons.
   *
   * @param {Event} event - The click event.
   */
  document.addEventListener('click', (event) => {
    const accordion = event.target.closest('[data-new-help-accordion]');
    if (!accordion) return;

    /* ── Live chat delegation ── */
    const chatLink = event.target.closest('a[href*="live-chat"]');
    const chatButton = event.target.closest('#openChatButton');

    if (chatLink || chatButton) {
      event.preventDefault();
      if (typeof openChatButtonClick === 'function') {
        openChatButtonClick();
      }
      return;
    }

    /* ── Animated close for <details> ── */
    const summary = event.target.closest('.new-help-accordion__summary');
    if (!summary) return;

    const details = summary.parentElement;
    if (!details || !details.open) return;        /* Opening — let native handle */

    event.preventDefault();                        /* Closing — we take over */
    const content = details.querySelector('.new-help-accordion__content');
    if (!content) return;

    details.dataset.closing = '';

    /**
     * After the collapse transition ends, remove the open attribute
     * and the data-closing flag so the element is fully closed.
     */
    const onTransitionEnd = (e) => {
      if (e.target !== content) return;
      content.removeEventListener('transitionend', onTransitionEnd);
      delete details.dataset.closing;
      details.removeAttribute('open');
    };

    content.addEventListener('transitionend', onTransitionEnd);

    /* Safety net — if the transition doesn't fire (e.g. reduced-motion) */
    setTimeout(() => {
      if (details.hasAttribute('data-closing')) {
        content.removeEventListener('transitionend', onTransitionEnd);
        delete details.dataset.closing;
        details.removeAttribute('open');
      }
    }, 400);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-help-action-button"] && !Shopify.designMode) return;
  try {
    
  const section = document.querySelector('.new-help-action-section');
  if (section) {
    section.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-action="trigger-chat"]');
      if (!trigger) return;

      event.preventDefault();

      /* openChatButtonClick() is a global function defined in layout/theme.liquid that triggers the INSIDE live chat widget (insideFrontInterface.openChatPane). */
      if (typeof openChatButtonClick === 'function') {
        openChatButtonClick();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-hero-banner"] && !Shopify.designMode) return;
  try {
    
  const heroSection = document.querySelector('.new-hero');
  const slideShowSpeedElement = document.querySelector('.new-hero-slideshow-speed');

  if (!heroSection || !slideShowSpeedElement) return;

  const banners = heroSection.querySelectorAll('.new-hero__banner');

  if (banners.length <= 1) return;

  const slideshowSpeed = parseInt(slideShowSpeedElement.dataset.slideshowSpeed || '4', 10) * 1000;
  let currentIndex = 0;
  let slideInterval;

  const showNextBanner = () => {
    const previousBanner = banners[currentIndex];
    const previousVideo = previousBanner.querySelector('video');
    if (previousVideo) {
      previousVideo.pause();
    }
    previousBanner.classList.remove('is-active');

    currentIndex = (currentIndex + 1) % banners.length;

    const nextBanner = banners[currentIndex];
    const nextVideo = banners[currentIndex].querySelector('video');
    nextBanner.classList.add('is-active');
    if (nextVideo) {
      nextVideo.currentTime = 0;
      nextVideo.play();
    }
  };

  const startSlideshow = () => {
    clearInterval(slideInterval);
    slideInterval = setInterval(showNextBanner, slideshowSpeed);
  };

  const pauseSlideshow = () => {
    clearInterval(slideInterval);
  };

  heroSection.addEventListener('mouseenter', pauseSlideshow);
  heroSection.addEventListener('mouseleave', startSlideshow);

  startSlideshow();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-instagram"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const instagramGrid = document.querySelector('.new-instagram-grid');
    if (!instagramGrid) return;

    const firstActiveImage = instagramGrid.querySelector('.new-instagram-grid__image.is-active');
    if (!firstActiveImage) return;

    const handleFirstInteraction = () => {
      if (firstActiveImage.classList.contains('is-active')) {
        firstActiveImage.classList.remove('is-active');
      }
      instagramGrid.removeEventListener('mouseover', handleFirstInteraction);
    };

    instagramGrid.addEventListener('mouseover', handleFirstInteraction);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-menus"]) return;
  try {
    
  const menu = document.querySelector('.js-new-header-menu');

  if (!menu) return;

  const parentMenu = menu.querySelector('.js-new-header-parent-menu');
  const menuImages = menu.querySelector('.js-new-header-menu-images');
  const ACTIVE_CHILD_MENU_CLASS = 'new-header-menus__children--is-active';
  const ACTIVE_GRANDCHILD_MENU_CLASS = 'new-header-menus__grandchildren--is-active';
  const ACTIVE_MENU_CONTAINER_CLASS = 'new-header-menus--is-child-active';
  const HIDING_CLASS = 'new-header-menus--is-hiding';
  const MENU_IS_ACTIVE_CLASS = 'new-header-menus--is-active';

  const resetGrandchildAccordions = (childMenu) => {
    const grandchildMenus = childMenu.querySelectorAll('.js-menu-grandchild-menu');
    grandchildMenus.forEach((grandchild, index) => {
      const ul = grandchild.querySelector('ul');
      const button = grandchild.querySelector('.js-menu-grandchild-link');

      grandchild.classList.remove(ACTIVE_GRANDCHILD_MENU_CLASS);
      button.setAttribute('aria-expanded', 'false');
      if (ul) {
        ul.style.height = null;
      }

    });
  };

  const closeAccordion = (accordion) => {
    const list = accordion.querySelector('ul');
    const button = accordion.querySelector('.js-menu-grandchild-link');

    accordion.classList.remove(ACTIVE_GRANDCHILD_MENU_CLASS);
    button.setAttribute('aria-expanded', 'false');
    if (!list) return;

    list.style.height = `${list.scrollHeight}px`;
    requestAnimationFrame(() => {
      list.style.height = null;
    });
  };

  const openAccordion = (accordion) => {
    const list = accordion.querySelector('ul');
    const button = accordion.querySelector('.js-menu-grandchild-link');

    accordion.classList.add(ACTIVE_GRANDCHILD_MENU_CLASS);
    button.setAttribute('aria-expanded', 'true');
    if (!list) return;

    list.style.height = `${list.scrollHeight}px`;
    list.addEventListener(
      'transitionend',
      () => {
        list.style.height = 'auto';
      },
      { once: true }
    );
  };

  const resetEntireMenu = () => {
    menu.classList.remove(ACTIVE_MENU_CONTAINER_CLASS);
    menu.querySelectorAll('.js-menu-parent-link').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
    menu.querySelectorAll('.js-menu-child-menu').forEach((childMenu) => {
      childMenu.classList.remove(ACTIVE_CHILD_MENU_CLASS);
      resetGrandchildAccordions(childMenu);
    });
    menu.classList.remove(HIDING_CLASS);
  };

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class' &&
        menu.classList.contains(MENU_IS_ACTIVE_CLASS) &&
        menu.classList.contains(HIDING_CLASS)
      ) {
        resetEntireMenu();
      }
    }
  });

  observer.observe(menu, { attributes: true });

  parentMenu.addEventListener('click', (event) => {
    const { target } = event;
    const parentButton = target.closest('.js-menu-parent-link');
    if (parentButton) {
      const childMenu = parentButton.nextElementSibling;
      if (childMenu && childMenu.matches('.js-menu-child-menu')) {
        menu.classList.add(ACTIVE_MENU_CONTAINER_CLASS);
        childMenu.classList.add(ACTIVE_CHILD_MENU_CLASS);
        parentButton.setAttribute('aria-expanded', 'true');
        resetGrandchildAccordions(childMenu);
      }
      return;
    }

    const grandchildLink = target.closest('.js-menu-grandchild-link');
    if (grandchildLink) {
      const grandchildMenu = grandchildLink.closest('.js-menu-grandchild-menu');
      const isActive = grandchildMenu.classList.contains(ACTIVE_GRANDCHILD_MENU_CLASS);
      if (isActive) {
        closeAccordion(grandchildMenu);
        return;
      }
      grandchildMenu.parentElement.querySelectorAll('.js-menu-grandchild-menu').forEach((item) => {
        if (item !== grandchildMenu && item.classList.contains(ACTIVE_GRANDCHILD_MENU_CLASS)) {
          closeAccordion(item);
        }
      });
      openAccordion(grandchildMenu);
    }
  });

  menu.addEventListener('click', (event) => {
    const { target } = event;
    const backButton = target.closest('.js-menu-child-close');
    if (backButton) {
      const childMenu = backButton.closest('.js-menu-child-menu');
      if (childMenu) {
        const parentButton = menu.querySelector(`[aria-controls="${childMenu.id}"]`);
        menu.classList.remove(ACTIVE_MENU_CONTAINER_CLASS);
        childMenu.classList.remove(ACTIVE_CHILD_MENU_CLASS);
        if (parentButton) {
          parentButton.setAttribute('aria-expanded', 'false');
        }
        childMenu.addEventListener(
          'transitionend',
          () => {
            resetGrandchildAccordions(childMenu);
          },
          { once: true }
        );
      }
      return;
    }

    const mainCloseButton = target.closest('.js-new-header-mobile-toggle');
    const isSearchClicked = target.classList.contains('js-search-trigger');

    if (mainCloseButton || isSearchClicked) {
      const announcementBar = document.querySelector('.new-announcement-bar');

      if (announcementBar) {
        announcementBar.classList.add('is-hover');
      }

      menu.classList.add(HIDING_CLASS);
      menu.classList.remove(MENU_IS_ACTIVE_CLASS);
      document.body.classList.remove('is-open-mobile-menu');
      window.scrollUtils.enableScroll();

      menu.addEventListener(
        'transitionend',
        function onMenuClose(e) {
          if (e.target === menu && e.propertyName === 'transform') {
            resetEntireMenu();
          }
        },
        { once: true }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-minicart"]) return;
  try {
    
  // --- UI STATE — scroll lock, minicart toggle ---
  let _savedScrollY = 0;

  function lockBodyScroll() {
    _savedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${_savedScrollY}px`;
    document.body.style.width = '100%';
    document.body.style.touchAction = 'none';
    window.scrollUtils.disableScroll();
  }

  function unlockBodyScroll() {
    window.scrollUtils.enableScroll();
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.position = '';
    document.body.style.touchAction = '';
    window.scrollTo(0, _savedScrollY);
  }

  function handleMinicartToggle() {
    const isOpening = !document.body.classList.contains('is-open-minicart');

    document.body.classList.toggle('is-open-minicart');

    if (isOpening) {
      // Restart shipping bar animation on open
      const shippingBarFill = document.querySelector('.new-minicart__shipping-bar-fill');
      if (shippingBarFill) {
        shippingBarFill.style.animation = 'none';
        shippingBarFill.offsetHeight;
        shippingBarFill.style.animation = '';
      }

      // Close mobile menu if open
      const mobileMenu = document.querySelector('.js-new-header-menu');
      if (mobileMenu && mobileMenu.classList.contains('new-header-menus--is-active')) {
        mobileMenu.classList.remove('new-header-menus--is-active');
        document.body.classList.remove('is-open-mobile-menu');
      }
      lockBodyScroll();
    } else {
      unlockBodyScroll();
      
      // Clear discount form state when closing
      const { input } = getDiscountUiElements();
      if (input) {
        input.value = '';
        input.blur();
        const applyBtn = document.querySelector('.js-new-minicart-discount-apply');
        if (applyBtn) {
          applyBtn.classList.add('is-disabled');
          applyBtn.disabled = true;
        }
      }
      setDiscountUiState({ open: false, isError: false });
      if (discountErrorTimer) {
        clearTimeout(discountErrorTimer);
        discountErrorTimer = null;
      }
    }
  }

  // --- CONSTANTS & STATE ---
  const SECTIONS_TO_FETCH = 'new-minicart,new-header';
  const DEBOUNCE_MS = 350;
  const pendingUpdates = new Map();
  let activeAbortController = null;
  let discountErrorTimer = null;
  const DISCOUNT_ERROR_MESSAGES = {
    invalid: 'This code is not valid, or may be store credit or a gift card.',
    removeFailed: 'Could not remove discount.',
  };

  const getDiscountUiElements = () => {
    const input = document.querySelector('.js-new-minicart-discount-input');
    const error = document.querySelector('.js-new-minicart-discount-error');
    const note = document.querySelector('.js-new-minicart-discount-note');
    const panel = document.querySelector('.js-new-minicart-discount-panel');
    const message = error?.querySelector('p');
    const bar = document.querySelector('.js-new-minicart-discount-error-bar');

    return { input, error, note, panel, message, bar };
  };

  const setDiscountUiState = ({ open = false, isError = false, message = null } = {}) => {
    const { input, error, note, panel, message: messageEl, bar } = getDiscountUiElements();

    if (input) input.classList.toggle('is-error', isError);
    if (error) error.classList.toggle('is-hidden', !isError);
    if (note) note.classList.toggle('is-hidden', isError);

    const shouldOpen = open || isError;
    if (panel) panel.classList.toggle('is-open', shouldOpen);
    if (input) input.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');

    if (isError && message && messageEl) {
      messageEl.textContent = message;
    }

    if (bar) {
      // Force restart of animation
      bar.style.animation = 'none';
      if (isError) {
        bar.offsetHeight; // trigger reflow
        bar.style.animation = 'minicart-discount-progress 5s linear forwards';
      }
    }
  };

  // --- UTILITIES — formatting, announcements, toasts ---

  // Aria-live status region for screen reader announcements
  const srStatus = document.createElement('div');
  srStatus.className = 'new-minicart__sr-status';
  srStatus.setAttribute('role', 'status');
  srStatus.setAttribute('aria-live', 'polite');
  srStatus.setAttribute('aria-atomic', 'true');
  document.querySelector('.new-minicart')?.appendChild(srStatus);

  const announce = (message) => {
    srStatus.textContent = '';
    // Brief delay so screen readers register the change
    requestAnimationFrame(() => {
      srStatus.textContent = message;
    });
  };

  // ── Toast notifications ──────────────────────────────────────────
  const showToast = (message, targetItemId = null, duration = 4000) => {
    const minicart = document.querySelector('.new-minicart');
    const body = minicart?.querySelector('.new-minicart__body');
    if (!minicart || !body) return;

    // Remove any existing toast
    minicart.querySelector('.new-minicart__toast')?.remove();

    const toast = document.createElement('div');
    toast.className = 'new-minicart__toast';
    toast.setAttribute('role', 'alert');

    // Text content
    const textSpan = document.createElement('span');
    textSpan.textContent = message;
    toast.appendChild(textSpan);

    // Progress bar
    const bar = document.createElement('div');
    bar.className = 'new-minicart__toast-bar';
    bar.style.setProperty('--toast-duration', `${duration}ms`);
    toast.appendChild(bar);

    // Append to body (scroll container)
    body.appendChild(toast);

    if (targetItemId) {
      const targetItem = body.querySelector(`.new-minicart__item[data-id="${targetItemId}"]`);
      if (targetItem) {
        const topPosition = targetItem.offsetTop + targetItem.offsetHeight - 5;
        toast.style.top = `${topPosition}px`;
        toast.style.setProperty('--toast-translate-y', '-100%');
      }
    }

    if (duration > 0) {
      setTimeout(() => {
        toast.classList.add('is-dismissing');
        toast.addEventListener('animationend', () => toast.remove(), { once: true });
      }, duration);
    }
  };

  // ── Cart badge animation ──────────────────────────────────────────
  const bumpCartBadge = () => {
    const cartBtn = document.querySelector('.new-minicart__cart-button');
    if (!cartBtn) return;
    cartBtn.classList.remove('is-bumping');
    // Force reflow to restart the animation
    void cartBtn.offsetWidth;
    cartBtn.classList.add('is-bumping');
    cartBtn.addEventListener('animationend', () => cartBtn.classList.remove('is-bumping'), { once: true });
  };

  /**
   * Filters accelerated checkout to ONLY show PayPal.
   * Persistent via MutationObserver to handle Shopify's dynamic rendering.
   */
  window.initPayButtonFilter = (rootNode = document) => {
    const container = rootNode.querySelector('#dynamic-checkout-cart');
    if (!container) return;

    const filterLogic = (parent) => {
      const el = parent.querySelector('shopify-accelerated-checkout-cart');
      if (!el) return;

      // 1. Remove non-PayPal button tags (including Shop Pay variations)
      el.querySelectorAll('shopify-shop-pay-button, shop-pay-wallet-button, shopify-google-pay-button, shopify-apple-pay-button').forEach(btn => btn.remove());

      // 2. Force the config manifest to only acknowledge PayPal
      const raw = el.getAttribute('wallet-configs');
      if (raw && raw.includes('paypal')) {
        try {
          const configs = JSON.parse(raw);
          if (configs.length > 1 || (configs[0] && configs[0].name !== 'paypal')) {
            const filtered = configs.filter(c => c.name === 'paypal');
            if (filtered.length > 0) {
              el.setAttribute('wallet-configs', JSON.stringify(filtered));
            }
          }
        } catch (e) {}
      }

      // 3. Keep only one skeleton loader to bridge the gap
      const skeletons = el.querySelectorAll('.wallet-cart-button-container');
      if (skeletons.length > 1) {
        skeletons.forEach((item, i) => { if (i > 0) item.remove(); });
      }

      // 4. "Poke" logic: If stuck in skeleton mode for too long, force a re-render
      // by slightly toggling an attribute that triggers the component's internal sync
      if (el.querySelector('.wallet-cart-grid--skeleton')) {
        if (!el.dataset.hydrationAttempted) {
          el.dataset.hydrationAttempted = 'true';
          setTimeout(() => {
            if (el.querySelector('.wallet-cart-grid--skeleton')) {
               const currentToken = el.getAttribute('access-token');
               if (currentToken) {
                 // Re-setting triggers attribute mutation
                 el.setAttribute('access-token', currentToken); 
               }
            }
          }, 2000);
        }
      }
    };

    // Monitor for changes (Shopify re-rendering or custom element hydration)
    const observer = new MutationObserver(() => filterLogic(container));
    observer.observe(container, { childList: true, subtree: true, attributes: true });

    // Initial run
    filterLogic(container);
  };

  // ═══════════════════════════════════════════════════
  // 4. OPTIMISTIC UI — visual feedback before server confirms
  // ═══════════════════════════════════════════════════

  /**
   * Formats a Shopify price-in-cents to the store's money format.
   * Falls back to a basic $X.XX format if the global format string is missing.
   */
  const formatMoney = (cents) => {
    const moneyFormat =
      window.theme?.moneyFormat ||
      document.querySelector('[data-money-format]')?.dataset.moneyFormat ||
      '$' + '{' + '{amount}}';
    const amount = (cents / 100).toFixed(2);
    return moneyFormat
      .replace('{' + '{amount}}', amount)
      .replace('{' + '{amount_with_comma_separator}}', amount.replace('.', ','));
  };

  /**
   * Helper to revert optimistic changes if a request fails.
   */
  const revertOptimisticUpdate = (itemEl) => {
    if (!itemEl) return;
    const oldQty = itemEl.dataset.oldQty;

    if (oldQty !== undefined) {
      const qtyInput = itemEl.querySelector('.js-minicart-quantity-input');
      if (qtyInput) qtyInput.value = oldQty;

      itemEl.querySelectorAll('.js-minicart-quantity').forEach((btn) => {
        btn.dataset.currentQty = oldQty;
      });
      delete itemEl.dataset.oldQty;
    }

    const oldVariantId = itemEl.dataset.oldVariantId;
    if (oldVariantId !== undefined) {
      const sizeSelect = itemEl.querySelector('.js-minicart-size-select');
      if (sizeSelect) sizeSelect.value = oldVariantId;
      delete itemEl.dataset.oldVariantId;
    }

    itemEl.classList.remove('is-pending', 'is-removing');
    itemEl.style.removeProperty('--item-height');
  };

  /**
   * Immediately updates a single line-item's displayed price and
   * recalculates the cart subtotal shown in the footer.
   */
  const applyOptimisticUpdate = (itemEl, newQty) => {
    if (!itemEl) return;

    const qtyInput = itemEl.querySelector('.js-minicart-quantity-input');
    if (qtyInput) {
      // Save current quantity before changing it, if not already saved
      if (!itemEl.dataset.oldQty) {
        itemEl.dataset.oldQty = qtyInput.value;
      }
      qtyInput.value = newQty;
    }

    // Update data-current-qty on buttons so subsequent clicks use the right base
    itemEl.querySelectorAll('.js-minicart-quantity').forEach((btn) => {
      btn.dataset.currentQty = newQty;
    });

    // Visual pending state
    itemEl.classList.add('is-pending');
  };

  /**
   * Applies optimistic UI and schedules a debounced server sync for quantity changes.
   * Shared between quantity buttons and direct input handlers.
   */
  const scheduleQuantityUpdate = (itemEl, productId, newQty, minicart) => {
    applyOptimisticUpdate(itemEl, newQty);
    setCheckoutSyncing(true);

    if (pendingUpdates.has(productId)) clearTimeout(pendingUpdates.get(productId));
    pendingUpdates.set(
      productId,
      setTimeout(() => {
        pendingUpdates.delete(productId);
        updateQuantityAndRefresh(productId, newQty, minicart);
      }, DEBOUNCE_MS)
    );
  };

  let _checkoutSyncTimeout = null;
  /**
   * Blocks the checkout button to prevent navigation during pending sync.
   * Also handles a safety fallback to re-enable elements if a network request hangs.
   */
  const setCheckoutSyncing = (syncing) => {
    const btn = document.querySelector('.button--checkout');
    const dynamicCheckout = document.querySelector('.dynamic-checkout__content');
    const minicart = document.querySelector('.new-minicart');

    if (_checkoutSyncTimeout) {
      clearTimeout(_checkoutSyncTimeout);
      _checkoutSyncTimeout = null;
    }

    if (syncing) {
      if (btn) btn.classList.add('is-syncing');
      if (dynamicCheckout) dynamicCheckout.classList.add('is-syncing');

      // Safety fallback: re-enable after 8 seconds if still stuck
      _checkoutSyncTimeout = setTimeout(() => {
        if (btn) btn.classList.remove('is-syncing');
        if (dynamicCheckout) dynamicCheckout.classList.remove('is-syncing');
        if (minicart) {
          minicart.classList.remove('is-loading');
          setDiscountLoading(false);
        }

        // Also clear any blurred/disabled items and REVERT their values
        document.querySelectorAll('.new-minicart__item.is-pending, .new-minicart__item.is-removing').forEach((el) => {
          revertOptimisticUpdate(el);
        });

        _checkoutSyncTimeout = null;
      }, 8000);
    } else {
      if (btn) btn.classList.remove('is-syncing');
      if (dynamicCheckout) dynamicCheckout.classList.remove('is-syncing');
      // On clear, also ensure no items are stuck in is-pending or is-removing
      document.querySelectorAll('.new-minicart__item.is-pending, .new-minicart__item.is-removing').forEach((el) => {
        revertOptimisticUpdate(el);
      });
    }
  };

  // --- EVENT BINDING ---
  function attachMinicartListeners() {
    const minicart = document.querySelector('.new-minicart');
    const minicartToggles = document.querySelectorAll('.js-new-minicart-toggle');
    const quantityBtns = document.querySelectorAll('.js-minicart-quantity');
    const quantityInputs = document.querySelectorAll('.js-minicart-quantity-input');
    const removeBtns = document.querySelectorAll('.js-minicart-remove-item');
    const discountRemove = document.querySelector('.js-minicart-discount-remove');
    const discountInput = document.querySelector('.js-new-minicart-discount-input');
    const discountApply = document.querySelector('.js-new-minicart-discount-apply');

    const sizeSelects = document.querySelectorAll('.js-minicart-size-select');

    if (!minicart || !minicartToggles) return;

    // TODO trap focus on minicart when open

    sizeSelects.forEach((select) => {
      select.addEventListener('change', async () => {
        const newVariantId = select.value;
        const item = select.closest('[data-id]');
        const itemKey = item?.dataset.key;

        if (!newVariantId || !item) return;

        // Save current variant for revert
        if (!item.dataset.oldVariantId) {
          item.dataset.oldVariantId = select.getAttribute('data-current-variant-id') || select.value;
        }

        item.classList.add('is-pending');
        setCheckoutSyncing(true);

        // Get current quantity to maintain it
        const quantityInput = item.querySelector('.js-minicart-quantity-input');
        let currentQty = 1;
        if (quantityInput) {
          currentQty = parseInt(quantityInput.value, 10);
        }

        // Single request: remove old variant + add new variant via cart/update.js
        const updates = {};
        if (itemKey) {
          updates[itemKey] = 0;
        } else {
          updates[item.dataset.id] = 0;
        }
        updates[newVariantId] = currentQty;

        try {
          const result = await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              updates: updates,
              sections: SECTIONS_TO_FETCH,
              sections_url: window.location.pathname,
            }),
          });

          if (!result.ok) {
            item.classList.remove('is-pending');
            setCheckoutSyncing(false);
            refreshMinicart(minicart);
            return;
          }

          const responseData = await result.json();
          await refreshMinicart(minicart, null, responseData.sections);
          setCheckoutSyncing(false);
        } catch (err) {
          item.classList.remove('is-pending');
          setCheckoutSyncing(false);
          refreshMinicart(minicart);
          return;
        }
      });
    });

    // Show the note panel when the inline discount input is focused
    const openDiscountNote = () => {
      if (!discountInput) return;
      // If error is already showing, don't change state (prevents restarting animation)
      if (!discountInput.classList.contains('is-error')) {
        setDiscountUiState({ open: true, isError: false });
      }
    };

    const closeDiscountNote = (e) => {
      if (!discountInput) return;
      // Small delay to allow click events on child elements to fire first
      setTimeout(() => {
        if (discountInput === document.activeElement) {
          return;
        }

        // Keep current UI state while a discount request is in-flight
        if (discountInput.classList.contains('is-loading')) return;

        // If there's an error, keep the panel open so the user can read it
        if (discountInput.classList.contains('is-error')) return;

        const hasValue = discountInput.value.trim().length > 0;
        setDiscountUiState({ open: hasValue, isError: false });
      }, 150);
    };

    discountInput?.addEventListener('focus', openDiscountNote);
    discountInput?.addEventListener('blur', closeDiscountNote);

    discountRemove?.addEventListener('click', () => {
      updateDiscountAndRefresh('', minicart);
    });

    const handleDiscountSubmit = () => {
      if (!discountInput || !discountApply) return;
      if (discountApply.classList.contains('is-disabled')) return;
      
      const discountCode = discountInput.value.trim();
      if (discountCode) {
        const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
        setDiscountUiState({ open: isTouchDevice, isError: false });
        if (!isTouchDevice) {
          discountInput.blur();
        }
        updateDiscountAndRefresh(discountCode, minicart);
      }
    };

    // Submit discount code on Enter
    discountInput?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        handleDiscountSubmit();
      }
    });

    discountApply?.addEventListener('click', (e) => {
      e.preventDefault();
      handleDiscountSubmit();
    });

    // Prevent input from blurring when the apply button is clicked
    discountApply?.addEventListener('mousedown', (e) => {
      e.preventDefault();
    });

    discountInput?.addEventListener('input', () => {
      const hasValue = discountInput.value.trim().length > 0;
      if (discountApply) {
        discountApply.classList.toggle('is-disabled', !hasValue);
        discountApply.disabled = !hasValue;
      }
      
      // Clear error state if user changes input
      if (discountErrorTimer || discountInput.classList.contains('is-error')) {
        if (discountErrorTimer) {
          clearTimeout(discountErrorTimer);
          discountErrorTimer = null;
        }
        setDiscountUiState({ open: hasValue, isError: false });
      }
    });

    minicartToggles.forEach((toggle) => {
      toggle.removeEventListener('click', handleMinicartToggle);
      toggle.addEventListener('click', handleMinicartToggle);
    });

    quantityInputs.forEach((input) => {
      input.addEventListener('change', () => {
        const newQty = parseInt(input.value, 10);
        const itemEl = input.closest('[data-id]');
        if (!itemEl?.dataset.id || isNaN(newQty)) return;
        scheduleQuantityUpdate(itemEl, itemEl.dataset.id, newQty, minicart);
      });
    });

    quantityBtns.forEach((button) => {
      button.addEventListener('click', () => {
        const currentQty = parseInt(button.dataset.currentQty, 10);
        const newQty = button.dataset.function === 'add' ? currentQty + 1 : currentQty - 1;
        const itemEl = button.closest('[data-id]');
        const productId = itemEl?.dataset.id;
        if (!productId) return;

        if (newQty < 1) {
          animateItemRemoval(itemEl);
          setCheckoutSyncing(true);
          updateQuantityAndRefresh(productId, 0, minicart);
          return;
        }

        scheduleQuantityUpdate(itemEl, productId, newQty, minicart);
      });
    });

    removeBtns.forEach((button) => {
      button.addEventListener('click', async () => {
        const itemEl = button.closest('[data-id]');
        const productId = itemEl?.dataset.id;
        if (!productId) return;

        // Cancel any pending debounced update for this item
        if (pendingUpdates.has(productId)) {
          clearTimeout(pendingUpdates.get(productId));
          pendingUpdates.delete(productId);
        }

        animateItemRemoval(itemEl);
        setCheckoutSyncing(true);
        updateQuantityAndRefresh(productId, 0, minicart);
      });
    });

    if (window.initSearchspringSliders) {
      window.initSearchspringSliders();
    }

    if (window.initPayButtonFilter) {
      window.initPayButtonFilter();
    }

    initSwipeToClose();
  }

  /**
   * Animates a line item out of the list before the server confirms removal.
   */
  const animateItemRemoval = (itemEl) => {
    if (!itemEl) return;

    const qtyInput = itemEl.querySelector('.js-minicart-quantity-input');
    if (qtyInput && !itemEl.dataset.oldQty) {
      itemEl.dataset.oldQty = qtyInput.value;
    }

    // Capture current height for the collapse animation
    itemEl.style.setProperty('--item-height', `${itemEl.offsetHeight}px`);
    itemEl.classList.add('is-removing');
  };

  // --- ORCHESTRATION — high-level update flows ---

  const updateQuantityAndRefresh = async (id, quantity, minicart) => {
    // Don't use the full overlay — the optimistic UI handles visual feedback.
    // Only clear previous errors and toasts.
    const errorElements = minicart.querySelectorAll('.is-error');
    errorElements?.forEach((el) => el.classList.remove('is-error'));
    minicart.querySelector('.new-minicart__toast')?.remove();

    const data = await updateQuantity(id, quantity);

    // Aborted request — a newer update superseded this one
    if (data === null) return;

    if (data && !data.error) {
      await refreshMinicart(minicart, null, data.sections);
      announce(quantity === 0 ? 'Item removed from bag' : `Quantity updated to ${quantity}`);
    } else {
      let errorMessage = 'Updating cart failed.';
      try {
        errorMessage = JSON.parse(data.details)?.message || data.error || errorMessage;
      } catch (_e) {
        errorMessage = data.error || errorMessage;
      }

      // Show toast for stock-limit and other errors
      announce(errorMessage);

      const errorProduct = minicart.querySelector(`[data-id="${id}"]`);

      if (errorProduct) {
        // Revert the optimistic removal animation if present
        errorProduct.classList.remove('is-removing');
        errorProduct.style.removeProperty('--item-height');
      }

      // Re-fetch to correct the UI state, then show the toast on the fresh DOM
      await refreshMinicart(minicart);
      showToast(errorMessage, id);
    }

    setCheckoutSyncing(false);
  };

  const setDiscountLoading = (loading) => {
    const input = document.querySelector('.js-new-minicart-discount-input');
    const tag = document.querySelector('.js-minicart-discount-remove');
    const applyBtn = document.querySelector('.js-new-minicart-discount-apply');
    const target = input || tag;
    if (!target) return;
    if (loading) {
      target.classList.add('is-loading');
      if (input) input.disabled = true;
      if (applyBtn) {
        applyBtn.classList.add('is-loading');
        applyBtn.disabled = true;
      }
    } else {
      target.classList.remove('is-loading');
      if (input) input.disabled = false;
      if (applyBtn) {
        applyBtn.classList.remove('is-loading');
        const isDisabled = !input?.value.trim();
        applyBtn.classList.toggle('is-disabled', isDisabled);
        applyBtn.disabled = isDisabled;
      }
    }
  };

  const updateDiscountAndRefresh = async (discount, minicart) => {
    setDiscountLoading(true);
    setCheckoutSyncing(true);

    if (discountErrorTimer) {
      clearTimeout(discountErrorTimer);
      discountErrorTimer = null;
    }

    const showError = (message = DISCOUNT_ERROR_MESSAGES.invalid) => {
      setDiscountUiState({ open: true, isError: true, message });
      setDiscountLoading(false);
      setCheckoutSyncing(false);
      
      // Auto-clear error and input after 5 seconds
      discountErrorTimer = setTimeout(() => {
        setDiscountUiState({ open: false, isError: false });
        const { input } = getDiscountUiElements();
        if (input) {
          input.value = '';
          const applyBtn = document.querySelector('.js-new-minicart-discount-apply');
          if (applyBtn) {
            applyBtn.classList.add('is-disabled');
            applyBtn.disabled = true;
          }
        }
        discountErrorTimer = null;
      }, 5000);
    };

    if (discount === '') {
      const data = await applyDiscountCode('');
      if (data && !data.error) {
        refreshMinicart(minicart, null, data.sections);
      } else {
        showError(DISCOUNT_ERROR_MESSAGES.removeFailed);
      }
      return;
    }

    const updatedCartData = await applyDiscountCode(discount);

    if (updatedCartData.error) {
      showError(DISCOUNT_ERROR_MESSAGES.invalid);
      return;
    }

    const wasApplied = updatedCartData.discount_codes?.some(
      (d) => d.code.toLowerCase() === discount.toLowerCase() && d.applicable
    );

    if (wasApplied) {
      refreshMinicart(minicart, null, updatedCartData.sections);
    } else {
      showError(DISCOUNT_ERROR_MESSAGES.invalid);
    }
  };

  // --- CART API ---

  /**
   * Shared cart API helper — POSTs to a Shopify cart endpoint,
   * normalises errors, and always returns { error, details } | cart data | null.
   */
  const cartFetch = async (endpoint, body, { signal } = {}) => {
    try {
      const result = await fetch(`${window.Shopify.routes.root}${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...body,
          sections: SECTIONS_TO_FETCH,
          sections_url: window.location.pathname,
        }),
        ...(signal && { signal }),
      });

      if (!result.ok) return { error: 'Network error', details: await result.text() };

      const data = await result.json();
      if (data?.status && data.status !== 200) {
        return { error: 'Shopify error', details: data.message || data.description, data };
      }
      return data;
    } catch (err) {
      if (err.name === 'AbortError') return null;
      return { error: 'Unexpected error', details: err };
    }
  };

  const updateQuantity = (id, quantity) => {
    if (activeAbortController) activeAbortController.abort();
    activeAbortController = new AbortController();
    return cartFetch('cart/change.js', { id, quantity }, { signal: activeAbortController.signal });
  };

  const applyDiscountCode = (discount) => cartFetch('cart/update.js', { discount });

  /**
   * Refreshes the minicart DOM.
   *
   * @param {Element}      minicart        – the current .new-minicart element
   * @param {Object|null}  errorData       – optional { productId, message } to display inline
   * @param {Object|null}  prefetchedSections – sections object returned by the Section Rendering API.
   *                                         If provided, skips the follow-up fetch entirely.
   */
  async function refreshMinicart(minicart, errorData = null, prefetchedSections = null) {
    try {
      let minicartHTML, headerHTML;

      if (prefetchedSections && prefetchedSections['new-minicart'] && prefetchedSections['new-header']) {
        minicartHTML = prefetchedSections['new-minicart'];
        headerHTML = prefetchedSections['new-header'];
      } else {
        const sectionsToFetch = ['new-minicart', 'new-header'];
        const sectionPromises = sectionsToFetch.map((sectionId) =>
          fetch(`${window.Shopify.routes.root}?section_id=${sectionId}`).then((res) => res.text())
        );
        const sections = await Promise.all(sectionPromises);
        minicartHTML = sections[0];
        headerHTML = sections[1];
      }

      const parser = new DOMParser();
      const minicartDoc = parser.parseFromString(minicartHTML, 'text/html');
      const headerDoc = parser.parseFromString(headerHTML, 'text/html');

      const newMinicart = minicartDoc.querySelector('.new-minicart');
      const newHeaderCartButton = headerDoc.querySelector('.new-header__icon--cart');
      const currentHeaderCartButton = document.querySelector('.new-header__icon--cart');

      if (newMinicart) {
        // Pre-filter accelerated checkout before it attaches to the live DOM
        // This ensures the custom element connects with a clean wallet-configs attribute
        if (window.initPayButtonFilter) {
          window.initPayButtonFilter(newMinicart);
        }

        const currentMinicart = document.querySelector('.new-minicart');

        // Capture which items were pending/removing for fade-in
        const affectedIds = new Set();
        currentMinicart
          ?.querySelectorAll('.new-minicart__item.is-pending, .new-minicart__item.is-removing')
          .forEach((el) => {
            if (el.dataset.id) affectedIds.add(el.dataset.id);
          });

        // Preserve the slider — collect ALL sibling nodes after .__items / .__empty
        const currentBody = currentMinicart?.querySelector('.new-minicart__body');
        const sliderFragment = document.createDocumentFragment();
        let hasSliderNodes = false;
        if (currentBody) {
          const contentEnd =
            currentBody.querySelector('.new-minicart__items') || currentBody.querySelector('.new-minicart__empty');
          if (contentEnd) {
            while (contentEnd.nextSibling) {
              sliderFragment.appendChild(contentEnd.nextSibling);
              hasSliderNodes = true;
            }
          }
        }

        currentMinicart.replaceWith(newMinicart);

        // Re-insert preserved slider nodes into the new DOM body
        if (hasSliderNodes) {
          const newBody = newMinicart.querySelector('.new-minicart__body');
          if (newBody) {
            // Remove server-rendered slider elements from the new DOM
            const newContentEnd =
              newBody.querySelector('.new-minicart__items') || newBody.querySelector('.new-minicart__empty');
            if (newContentEnd) {
              while (newContentEnd.nextSibling) {
                newContentEnd.nextSibling.remove();
              }
            }
            // Append the preserved (live) slider nodes
            newBody.appendChild(sliderFragment);
          }
        }

        // Fade in only the items that were being updated
        if (affectedIds.size > 0) {
          affectedIds.forEach((id) => {
            const freshItem = newMinicart.querySelector(`.new-minicart__item[data-id="${id}"]`);
            if (freshItem) freshItem.classList.add('is-fresh');
          });
        }

        // Empty cart crossfade + hide all slider content
        const emptyState = newMinicart.querySelector('.new-minicart__empty');
        if (emptyState) {
          emptyState.classList.add('is-entering');
          // Hide everything after the empty state div (slider header, Searchspring, etc.)
          let sibling = emptyState.nextElementSibling;
          while (sibling) {
            sibling.style.display = 'none';
            sibling = sibling.nextElementSibling;
          }
        }

        // Re-append aria-live region
        newMinicart.appendChild(srStatus);

        // Bump the minicart bag badge
        bumpCartBadge();
      }

      if (newHeaderCartButton && currentHeaderCartButton) {
        currentHeaderCartButton.innerHTML = newHeaderCartButton.innerHTML;
      }
      attachMinicartListeners();

      // Trigger Shopify's global button re-init if available, common fix for AJAX cart integrations
      if (window.Shopify && window.Shopify.PaymentButton) {
        window.Shopify.PaymentButton.init();
      }



      if (errorData && errorData.productId && errorData.message && newMinicart) {
        showToast(errorData.message, errorData.productId);
      }
    } catch {
      // Errors are silently caught — the finally block ensures UI is always cleaned up
    } finally {
      minicart?.classList.remove('is-loading');
      setDiscountLoading(false);
      setCheckoutSyncing(false);
    }
  }

  // --- INITIALISATION ---

  const minicartOverlay = document.createElement('div');
  minicartOverlay.classList.add('new-minicart-overlay');
  document.body.appendChild(minicartOverlay);

  minicartOverlay.addEventListener('click', () => {
    handleMinicartToggle();
  });

  function initSwipeToClose() {
    const minicart = document.querySelector('.new-minicart');
    const overlay = minicartOverlay;
    if (!minicart) return;

    // Skip gesture tracking if user prefers reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let startX = 0;
    let startY = 0;
    let currentX = 0;
    let startTime = 0;
    let isSwiping = false;
    let isScrolling = null; // null = undecided, true = vertical scroll, false = horizontal swipe
    const DISMISS_THRESHOLD = 100; // px
    const VELOCITY_THRESHOLD = 0.4; // px/ms
    const SWIPE_ZONE_RATIO = 0.45; // left 45% of drawer activates swipe

    minicart.addEventListener(
      'touchstart',
      function (e) {
        if (!document.body.classList.contains('is-open-minicart')) return;

        const touch = e.touches[0];
        const target = e.target;

        // Don't activate swipe on sliders / recommendation carousels
        if (target.closest('.js-new-slider-component')) {
          return;
        }

        const drawerRect = minicart.getBoundingClientRect();
        const touchRelativeX = touch.clientX - drawerRect.left;

        // Only activate swipe from the left portion of the drawer
        if (touchRelativeX > drawerRect.width * SWIPE_ZONE_RATIO) return;

        startX = touch.clientX;
        startY = touch.clientY;
        currentX = 0;
        startTime = Date.now();
        isSwiping = true;
        isScrolling = null;
      },
      { passive: true }
    );

    minicart.addEventListener(
      'touchmove',
      function (e) {
        if (!isSwiping) return;

        const touch = e.touches[0];
        const deltaX = touch.clientX - startX;
        const deltaY = touch.clientY - startY;

        // Determine direction on first meaningful move
        if (isScrolling === null) {
          if (Math.abs(deltaX) > 8 || Math.abs(deltaY) > 8) {
            isScrolling = Math.abs(deltaY) > Math.abs(deltaX);
          }
          if (isScrolling === null) return; // Not enough movement yet
        }

        // If user is scrolling vertically, bail out
        if (isScrolling) {
          isSwiping = false;
          return;
        }

        // Horizontal swipe detected — prevent vertical scrolling
        e.preventDefault();

        if (deltaX > 0) {
          // Swiping right (toward close) — follow finger 1:1
          currentX = deltaX;
        } else {
          // Prevent dragging past the open position (no leftward movement)
          currentX = 0;
        }

        // Apply transform directly for real-time tracking (no transition)
        minicart.style.transition = 'none';
        minicart.style.transform = `translateX(${currentX}px)`;

        // Fade overlay proportionally on desktop
        if (window.innerWidth >= 768 && overlay) {
          const progress = Math.min(Math.max(deltaX / (minicart.offsetWidth * 0.5), 0), 1);
          overlay.style.transition = 'none';
          overlay.style.opacity = 1 - progress;
        }
      },
      { passive: false }
    );

    minicart.addEventListener(
      'touchend',
      function (e) {
        if (!isSwiping || isScrolling) {
          isSwiping = false;
          isScrolling = null;
          return;
        }

        isSwiping = false;
        isScrolling = null;

        const elapsed = Date.now() - startTime;
        const velocity = Math.abs(currentX) / elapsed;
        const shouldDismiss = currentX > DISMISS_THRESHOLD || (currentX > 30 && velocity > VELOCITY_THRESHOLD);

        if (shouldDismiss) {
          // Animate out to the right from current position
          minicart.style.transition = 'transform 0.28s cubic-bezier(0.32, 0.72, 0, 1)';
          minicart.style.transform = 'translateX(100%)';

          if (window.innerWidth >= 768 && overlay) {
            overlay.style.transition = 'opacity 0.28s cubic-bezier(0.32, 0.72, 0, 1)';
            overlay.style.opacity = '0';
          }

          // Wait for the animation then clean up and toggle state
          const onDismissEnd = () => {
            minicart.removeEventListener('transitionend', onDismissEnd);
            minicart.style.transition = '';
            minicart.style.transform = '';
            if (overlay) {
              overlay.style.transition = '';
              overlay.style.opacity = '';
            }
            // Remove the open state (toggle handles scroll unlock)
            document.body.classList.remove('is-open-minicart');
            unlockBodyScroll();
          };
          minicart.addEventListener('transitionend', onDismissEnd, { once: true });

          // Fallback timeout in case transitionend doesn't fire
          setTimeout(onDismissEnd, 350);
        } else {
          // Snap back to open position with spring curve
          minicart.style.transition = 'transform 0.35s cubic-bezier(0.32, 0.72, 0, 1)';
          minicart.style.transform = 'translateX(0)';

          if (window.innerWidth >= 768 && overlay) {
            overlay.style.transition = 'opacity 0.35s cubic-bezier(0.32, 0.72, 0, 1)';
            overlay.style.opacity = '1';
          }

          const onSnapBack = () => {
            minicart.removeEventListener('transitionend', onSnapBack);
            minicart.style.transition = '';
            minicart.style.transform = '';
            if (overlay) {
              overlay.style.transition = '';
              overlay.style.opacity = '';
            }
          };
          minicart.addEventListener('transitionend', onSnapBack, { once: true });
          setTimeout(onSnapBack, 400);
        }

        currentX = 0;
      },
      { passive: true }
    );
  }

  const mobileMenuOverlay = document.createElement('div');
  mobileMenuOverlay.classList.add('new-mobile-menu-overlay');
  document.body.appendChild(mobileMenuOverlay);

  mobileMenuOverlay.addEventListener('click', () => {
    const mobileMenu = document.querySelector('.js-new-header-menu');
    if (mobileMenu) {
      mobileMenu.classList.add('new-header-menus--is-hiding');
      mobileMenu.classList.remove('new-header-menus--is-active');
      document.body.classList.remove('is-open-mobile-menu');
      window.scrollUtils.enableScroll();
    }
  });

  const nextPaint = () => new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));

  document.addEventListener('cart:added', async (e) => {
    const minicart = document.querySelector('.new-minicart');
    await refreshMinicart(minicart);

    await nextPaint();

    if (!document.body.classList.contains('is-open-minicart')) {
      handleMinicartToggle();
    }
  });

  attachMinicartListeners();

  document.addEventListener('searchspring:slider:initialized', (e) => {
    const slider = e.detail.slider;
    if (!slider) return;

    const minicart = slider.closest('.new-minicart');
    if (!minicart) return;

    const prevBtn = minicart.querySelector('.new-minicart__slider-arrow--prev');
    const nextBtn = minicart.querySelector('.new-minicart__slider-arrow--next');

    if (prevBtn && nextBtn && slider.sliderInstance) {
      // Remove old listeners using cloneNode
      const newPrev = prevBtn.cloneNode(true);
      const newNext = nextBtn.cloneNode(true);
      prevBtn.parentNode.replaceChild(newPrev, prevBtn);
      nextBtn.parentNode.replaceChild(newNext, nextBtn);

      newPrev.addEventListener('click', () => slider.sliderInstance.prev());
      newNext.addEventListener('click', () => slider.sliderInstance.next());
    }

    // Quick add-to-cart: intercept clicks on slider items with data-quick-add
    slider.addEventListener('click', async (e) => {
      const item = e.target.closest('[data-quick-add]');
      if (!item) return;

      e.preventDefault();
      e.stopPropagation();

      const variantId = item.dataset.variantId;
      if (!variantId) return;

      item.classList.add('is-adding');

      try {
        const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
        });

        if (!res.ok) return;

        await refreshMinicart(minicart);
      } finally {
        item.classList.remove('is-adding');
      }
    });
  });

  // DEV: Open minicart if ?cart is present in the URL
  if (window.location.search.includes('cart')) {
    handleMinicartToggle();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-size-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const toggleContainer = document.querySelector('.new-size-guide-toggle');
    const tableCm = document.querySelector('.new-size-table--cm');
    const tableIn = document.querySelector('.new-size-table--in');

    if (toggleContainer && tableCm && tableIn) {
      const btnCm = toggleContainer.querySelector('.js-toggle-cm');
      const btnIn = toggleContainer.querySelector('.js-toggle-in');
      const btnSwitch = toggleContainer.querySelector('.js-toggle-switch');

      const toggleToInches = () => {
        toggleContainer.setAttribute('data-unit', 'in');
        btnCm.setAttribute('data-state', 'inactive');
        btnIn.setAttribute('data-state', 'active');
        tableCm.setAttribute('data-state', 'inactive');
        tableIn.setAttribute('data-state', 'active');
      };

      const toggleToCm = () => {
        toggleContainer.setAttribute('data-unit', 'cm');
        btnCm.setAttribute('data-state', 'active');
        btnIn.setAttribute('data-state', 'inactive');
        tableCm.setAttribute('data-state', 'active');
        tableIn.setAttribute('data-state', 'inactive');
      };

      btnIn.addEventListener('click', toggleToInches);
      btnCm.addEventListener('click', toggleToCm);
      btnSwitch.addEventListener('click', () => {
        if (toggleContainer.getAttribute('data-unit') === 'cm') {
          toggleToInches();
        } else {
          toggleToCm();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-subcollection-links"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('.subcollection-links-container');

    containers.forEach((container) => {
      const list = container.querySelector('.subcollection-links');
      const wrapper = container.querySelector('.subcollection-links-wrapper');

      if (!list || !wrapper) return;

      const checkScroll = () => {
        const tolerance = 2;
        const canScrollRight = list.scrollWidth > list.clientWidth + list.scrollLeft + tolerance;
        const canScrollLeft = list.scrollLeft > tolerance;

        wrapper.setAttribute('data-can-scroll-right', canScrollRight);
        wrapper.setAttribute('data-can-scroll-left', canScrollLeft);
      };

      checkScroll();

      list.addEventListener('scroll', checkScroll, { passive: true });
      window.addEventListener('resize', checkScroll, { passive: true });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-recommendations"] && !Shopify.designMode) return;
  try {
    
(function() {
  const PREFIX = 'Peppermayo Exclusive';
  const TITLE_SELECTOR = '.product-item__name';
  const CONTAINER_SELECTOR = '.ss__recommendation';

  function cleanProductTitle(title) {
    if (!title) return title;
    return title.replace(PREFIX, '').trim();
  }

  function cleanTitleElement(el) {
    if (!el.closest(CONTAINER_SELECTOR)) return;
    if (el.textContent.includes(PREFIX)) {
      el.textContent = cleanProductTitle(el.textContent);
    }
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        if (node.matches?.(TITLE_SELECTOR)) {
          cleanTitleElement(node);
        }

        node.querySelectorAll?.(TITLE_SELECTOR).forEach(cleanTitleElement);
      });
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(`${CONTAINER_SELECTOR} ${TITLE_SELECTOR}`).forEach(cleanTitleElement);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-collection-dev"] && !Shopify.designMode) return;
  try {
    
(function() {
  const PREFIX = 'Peppermayo Exclusive';
  const TITLE_SELECTOR = '.product-item__name a';
  const CONTAINER_SELECTOR = '#template-collection.ss__content';

  function cleanProductTitle(title) {
    if (!title) return title;
    
    // Remove the prefix
    let cleaned = title.replace(new RegExp(PREFIX, 'g'), '').trim();
    
    // Check for duplicate text
    const half = Math.floor(cleaned.length / 2);
    const firstHalf = cleaned.substring(0, half).trim();
    const secondHalf = cleaned.substring(half).trim();
    
    if (firstHalf === secondHalf) {
      cleaned = firstHalf;
    }
    
    return cleaned;
  }

  function cleanTitleElement(el) {
    if (!el.closest(CONTAINER_SELECTOR)) return;
    
    const text = el.textContent;
    const cleaned = cleanProductTitle(text);

    if (text !== cleaned) {
      el.textContent = cleaned;
    }
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {

      if (mutation.type === 'characterData') {
        const el = mutation.target.parentElement?.closest(TITLE_SELECTOR);
        if (el) cleanTitleElement(el);
        return;
      }

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const el = node.parentElement?.closest(TITLE_SELECTOR);
          if (el) cleanTitleElement(el);
          return;
        }

        if (node.nodeType !== Node.ELEMENT_NODE) return;

        if (node.matches?.(TITLE_SELECTOR)) {
          cleanTitleElement(node);
        }

        node.querySelectorAll?.(TITLE_SELECTOR).forEach(cleanTitleElement);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(`${CONTAINER_SELECTOR} ${TITLE_SELECTOR}`).forEach(cleanTitleElement);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-collection-generic-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const PREFIX = 'Peppermayo Exclusive';
    const TITLE_SELECTOR = '.product-item__name a';
    const CONTAINER_SELECTOR = '#template-collection.ss__content';

    function cleanProductTitle(title) {
      if (!title) return title;

      // Remove the prefix
      let cleaned = title.replace(new RegExp(PREFIX, 'g'), '').trim();

      // Check for duplicate text
      const half = Math.floor(cleaned.length / 2);
      const firstHalf = cleaned.substring(0, half).trim();
      const secondHalf = cleaned.substring(half).trim();

      if (firstHalf === secondHalf) {
        cleaned = firstHalf;
      }

      return cleaned;
    }

    function cleanTitleElement(el) {
      if (!el.closest(CONTAINER_SELECTOR)) return;

      const text = el.textContent;
      const cleaned = cleanProductTitle(text);

      if (text !== cleaned) {
        el.textContent = cleaned;
      }
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          const el = mutation.target.parentElement?.closest(TITLE_SELECTOR);
          if (el) cleanTitleElement(el);
          return;
        }

        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const el = node.parentElement?.closest(TITLE_SELECTOR);
            if (el) cleanTitleElement(el);
            return;
          }

          if (node.nodeType !== Node.ELEMENT_NODE) return;

          if (node.matches?.(TITLE_SELECTOR)) {
            cleanTitleElement(node);
          }

          node.querySelectorAll?.(TITLE_SELECTOR).forEach(cleanTitleElement);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll(`${CONTAINER_SELECTOR} ${TITLE_SELECTOR}`).forEach(cleanTitleElement);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-collection-sale"]) return;
  try {
    
(function() {
  const PREFIX = 'Peppermayo Exclusive';
  const TITLE_SELECTOR = '.product-item__name a';
  const CONTAINER_SELECTOR = '#template-collection.ss__content';

  function cleanProductTitle(title) {
    if (!title) return title;
    
    // Remove the prefix
    let cleaned = title.replace(new RegExp(PREFIX, 'g'), '').trim();
    
    // Check for duplicate text
    const half = Math.floor(cleaned.length / 2);
    const firstHalf = cleaned.substring(0, half).trim();
    const secondHalf = cleaned.substring(half).trim();
    
    if (firstHalf === secondHalf) {
      cleaned = firstHalf;
    }
    
    return cleaned;
  }

  function cleanTitleElement(el) {
    if (!el.closest(CONTAINER_SELECTOR)) return;
    
    const text = el.textContent;
    const cleaned = cleanProductTitle(text);

    if (text !== cleaned) {
      el.textContent = cleaned;
    }
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {

      if (mutation.type === 'characterData') {
        const el = mutation.target.parentElement?.closest(TITLE_SELECTOR);
        if (el) cleanTitleElement(el);
        return;
      }

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const el = node.parentElement?.closest(TITLE_SELECTOR);
          if (el) cleanTitleElement(el);
          return;
        }

        if (node.nodeType !== Node.ELEMENT_NODE) return;

        if (node.matches?.(TITLE_SELECTOR)) {
          cleanTitleElement(node);
        }

        node.querySelectorAll?.(TITLE_SELECTOR).forEach(cleanTitleElement);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(`${CONTAINER_SELECTOR} ${TITLE_SELECTOR}`).forEach(cleanTitleElement);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    /* 
    const initTrustBlocksCarousel = () => {
      const carousels = document.querySelectorAll('[data-trust-blocks-carousel]');
      
      carousels.forEach(container => {
        const blocks = container.querySelectorAll('.product-trust-block');
        if (blocks.length <= 1) return;
        
        let currentIndex = 0;
        let intervalId;
        
        const startCarousel = () => {
          container.classList.add('carousel-active');
          blocks.forEach((block, index) => {
            if (index === currentIndex) {
              block.classList.add('is-visible');
            } else {
              block.classList.remove('is-visible');
            }
          });
          
          intervalId = setInterval(() => {
            blocks[currentIndex].classList.remove('is-visible');
            currentIndex = (currentIndex + 1) % blocks.length;
            blocks[currentIndex].classList.add('is-visible');
          }, 3000);
        };
        
        startCarousel();
      });
    };
    
    initTrustBlocksCarousel();
    */
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-search-main"] && !Shopify.designMode) return;
  try {
    
(function() {
  const PREFIX = 'Peppermayo Exclusive';
  const TITLE_SELECTOR = '.product-item__name a';
  const CONTAINER_SELECTOR = '#template-collection.ss__content';

  function cleanProductTitle(title) {
    if (!title) return title;
    
    // Remove the prefix
    let cleaned = title.replace(new RegExp(PREFIX, 'g'), '').trim();
    
    // Check for duplicate text
    const half = Math.floor(cleaned.length / 2);
    const firstHalf = cleaned.substring(0, half).trim();
    const secondHalf = cleaned.substring(half).trim();
    
    if (firstHalf === secondHalf) {
      cleaned = firstHalf;
    }
    
    return cleaned;
  }

  function cleanTitleElement(el) {
    if (!el.closest(CONTAINER_SELECTOR)) return;
    
    const text = el.textContent;
    const cleaned = cleanProductTitle(text);

    if (text !== cleaned) {
      el.textContent = cleaned;
    }
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {

      if (mutation.type === 'characterData') {
        const el = mutation.target.parentElement?.closest(TITLE_SELECTOR);
        if (el) cleanTitleElement(el);
        return;
      }

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const el = node.parentElement?.closest(TITLE_SELECTOR);
          if (el) cleanTitleElement(el);
          return;
        }

        if (node.nodeType !== Node.ELEMENT_NODE) return;

        if (node.matches?.(TITLE_SELECTOR)) {
          cleanTitleElement(node);
        }

        node.querySelectorAll?.(TITLE_SELECTOR).forEach(cleanTitleElement);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(`${CONTAINER_SELECTOR} ${TITLE_SELECTOR}`).forEach(cleanTitleElement);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-announcement-bar"]) return;
  try {
    
  (function () {
    'use strict';

    const section = document.querySelector('.v2-announcement-bar');
    if (!section) return;

    const slides = section.querySelectorAll('.v2-announcement-bar__slide');
    if (slides.length < 2) return;

    const ACTIVE_CLASS = 'v2-announcement-bar__slide--active';
    const autoSlideEnabled = slides[0].dataset.autoSlide === 'true';
    const slideInterval = parseInt(slides[0].dataset.slideInterval, 10) || 3000;

    let currentSlide = 0;
    let intervalId = null;

    /**
     * Display the slide at the given index and update ARIA attributes.
     * @param {number} index - Zero-based slide index
     */
    const showSlide = (index) => {
      slides.forEach((slide, i) => {
        const isActive = i === index;
        slide.classList.toggle(ACTIVE_CLASS, isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
    };

    /** Advance to the next slide (wraps around). */
    const nextSlide = () => {
      currentSlide = (currentSlide + 1) % slides.length;
      showSlide(currentSlide);
    };

    /** Start the auto-rotate interval. */
    const startAutoSlide = () => {
      if (intervalId !== null) return;
      intervalId = setInterval(nextSlide, slideInterval);
    };

    /** Stop the auto-rotate interval. */
    const stopAutoSlide = () => {
      if (intervalId === null) return;
      clearInterval(intervalId);
      intervalId = null;
    };

    /* ── Auto-slide with pause on hover & focus ──── */

    if (autoSlideEnabled && !window.v2Utils?.prefersReducedMotion) {
      startAutoSlide();

      section.addEventListener('mouseenter', stopAutoSlide);
      section.addEventListener('mouseleave', startAutoSlide);
      section.addEventListener('focusin', stopAutoSlide);
      section.addEventListener('focusout', startAutoSlide);
    }

    /* ── Emit hover event for header transparent state ── */

    section.addEventListener('mouseenter', () => {
      window.v2Utils?.emit('v2:announcement-hover', { isHover: true });
    });

    section.addEventListener('mouseleave', () => {
      window.v2Utils?.emit('v2:announcement-hover', { isHover: false });
    });

    /* ── Listen for sticky-change from header ──── */

    window.v2Utils?.on('v2:sticky-change', (e) => {
      section.classList.toggle('is-sticky', e.detail.isSticky);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-header"]) return;
  try {
    
  (function () {
    'use strict';

    const { emit, on, throttle } = window.v2Utils || {};
    if (!emit) return;

    /* ── DOM Cache ────────────────────────────────── */

    const header = document.querySelector('.v2-header');
    if (!header) return;

    const announcementBar = document.querySelector('.v2-announcement-bar');
    const overlay = header.querySelector('.js-v2-page-overlay');
    const desktopNav = header.querySelector('.js-v2-header-menu-desktop');
    const mobileToggle = header.querySelector('.js-v2-mobile-menu-toggle');
    const sentinel = header.parentElement?.querySelector('.v2-header-sentinel');
    const isHomepage = document.body.classList.contains('template-index');

    /* ── Constants ────────────────────────────────── */

    const STICKY_CLASS = 'v2-header--is-sticky';
    const HOVER_CLASS = 'v2-header--is-hover';
    const SCROLLED_CLASS = 'v2-header--is-scrolled';
    const ANNOUNCEMENT_VISIBLE_CLASS = 'v2-announcement-bar-visible';

    /* ── State ────────────────────────────────────── */

    let isSticky = !isHomepage;
    let isMobileMenuOpen = false;

    /* ── Sticky Logic ────────────────────────────── */

    /**
     * Apply or remove sticky state and emit event.
     * @param {boolean} sticky - Whether header should be sticky
     */
    const setStickyState = (sticky) => {
      if (sticky === isSticky) return;
      isSticky = sticky;
      header.classList.toggle(STICKY_CLASS, sticky);
      emit('v2:sticky-change', { isSticky: sticky });

      if (sticky) {
        header.classList.remove(HOVER_CLASS);
      }
    };

    if (isHomepage && sentinel) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setStickyState(!entry.isIntersecting);
        },
        { threshold: [0] }
      );
      observer.observe(sentinel);

      /* Handle page load with scroll position already past sentinel */
      if (window.scrollY > 0) {
        setStickyState(true);
      }
    } else {
      /* Non-homepage: always sticky */
      header.classList.add(STICKY_CLASS);
      emit('v2:sticky-change', { isSticky: true });
    }

    /* ── Transparent / Opaque Logic (homepage) ──── */

    /**
     * Add opaque hover state (only when not already sticky).
     */
    const addHover = () => {
      if (isSticky) return;
      header.classList.add(HOVER_CLASS);
      if (announcementBar) announcementBar.classList.add('is-hover');
    };

    /**
     * Remove opaque hover state.
     * Checks related target to avoid flicker when moving between header/announcement/desktop-menu.
     * @param {MouseEvent} event
     */
    const removeHover = (event) => {
      const related = event?.relatedTarget;

      if (
        related &&
        (header.contains(related) ||
          (announcementBar && announcementBar.contains(related)))
      ) {
        return;
      }

      if (!isSticky) {
        header.classList.remove(HOVER_CLASS);
        if (announcementBar) announcementBar.classList.remove('is-hover');
      }

      emit('v2:desktop-menu-close', {});
    };

    if (isHomepage) {
      header.addEventListener('mouseenter', addHover);
      header.addEventListener('mouseleave', removeHover);
    }

    /* ── Announcement Bar Hover → Header Hover ──── */

    on('v2:announcement-hover', (e) => {
      if (e.detail.isHover) {
        addHover();
      }
    });

    if (announcementBar && isHomepage) {
      announcementBar.addEventListener('mouseenter', addHover);
      announcementBar.addEventListener('mouseleave', removeHover);
    }

    /* ── Desktop Menu Event Delegation ────────────── */

    if (desktopNav) {
      desktopNav.addEventListener('mouseover', (event) => {
        const link = event.target.closest('a[data-menu-id]');
        if (!link) return;
        emit('v2:desktop-menu-open', { menuId: link.dataset.menuId });
      });
    }

    /* ── Mobile Menu Toggle ───────────────────────── */

    if (mobileToggle) {
      mobileToggle.addEventListener('click', () => {
        isMobileMenuOpen = !isMobileMenuOpen;
        mobileToggle.setAttribute('aria-expanded', String(isMobileMenuOpen));
        mobileToggle.setAttribute('aria-label', isMobileMenuOpen ? 'Close menu' : 'Open menu');

        emit('v2:mobile-menu-toggle', { isOpen: isMobileMenuOpen });

        if (isMobileMenuOpen) {
          emit('v2:overlay-show', { source: 'mobile-menu' });
        } else {
          emit('v2:overlay-hide', { source: 'mobile-menu' });
        }
      });

      /* Sync state if menu is closed externally */
      on('v2:mobile-menu-toggle', (e) => {
        if (!e.detail.isOpen && isMobileMenuOpen) {
          isMobileMenuOpen = false;
          mobileToggle.setAttribute('aria-expanded', 'false');
          mobileToggle.setAttribute('aria-label', 'Open menu');
        }
      });
    }

    /* ── Announcement Bar Scroll Behaviour ────────── */

    if (announcementBar) {
      const announcementBarHeight = announcementBar.offsetHeight;
      let lastScrollY = window.scrollY;

      const handleScroll = throttle(() => {
        const currentScrollY = window.scrollY;

        if (currentScrollY < lastScrollY && currentScrollY > announcementBarHeight) {
          /* Scrolling up past announcement bar */
          header.classList.add(SCROLLED_CLASS);
          document.body.classList.add(ANNOUNCEMENT_VISIBLE_CLASS);
          announcementBar.classList.add('is-hover');
          announcementBar.classList.add('is-sticky');
        } else if (currentScrollY > lastScrollY && currentScrollY > announcementBarHeight) {
          /* Scrolling down past announcement bar */
          header.classList.remove(SCROLLED_CLASS);
          document.body.classList.remove(ANNOUNCEMENT_VISIBLE_CLASS);
        } else if (currentScrollY <= announcementBarHeight) {
          /* At top */
          header.classList.remove(SCROLLED_CLASS);
          document.body.classList.remove(ANNOUNCEMENT_VISIBLE_CLASS);
          announcementBar.classList.remove('is-hover');
          announcementBar.classList.remove('is-sticky');
        }

        lastScrollY = currentScrollY;
      });

      window.addEventListener('scroll', handleScroll, { passive: true });
    }

    /* ── Overlay Management ────────────────────────── */

    on('v2:overlay-show', (e) => {
      if (!overlay) return;
      overlay.setAttribute('data-state', 'visible');
      overlay.setAttribute('aria-hidden', 'false');
      window.v2Utils.lockScroll(e.detail.source || 'overlay');
    });

    on('v2:overlay-hide', (e) => {
      if (!overlay) return;
      overlay.setAttribute('data-state', '');
      overlay.setAttribute('aria-hidden', 'true');
      window.v2Utils.unlockScroll(e.detail.source || 'overlay');
    });

    /* Close overlay on click */
    if (overlay) {
      overlay.addEventListener('click', () => {
        emit('v2:overlay-hide', { source: 'overlay-click' });
        emit('v2:desktop-menu-close', {});
        if (isMobileMenuOpen) {
          isMobileMenuOpen = false;
          emit('v2:mobile-menu-toggle', { isOpen: false });
        }
      });
    }

    /* ── Search Trigger (placeholder — full implementation Phase 6) ── */

    const searchTriggers = header.querySelectorAll('.js-v2-search-trigger');
    searchTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const isMobile = window.innerWidth < 768;
        emit('v2:search-open', { mode: isMobile ? 'mobile' : 'desktop' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
